import { gql } from "gql";

export const REMOVE_COMPANY_DOCUMENT_CONFIRMATION = gql(/* GraphQL */ `
  mutation RemoveCompanyDocumentConfirmations($ids: [ID!]!) {
    removeCompanyDocumentConfirmations(ids: $ids)
  }
`);
